import Phaser from 'phaser';
import { SceneKeys } from '../game/Constants';
import { GameState } from '../game/GameState';
import { SaveManager } from '../systems/SaveManager';
import { VisualTheme, addPanel } from '../ui/VisualTheme';
import { createTextButton } from '../ui/components/UIButton';

export class PauseScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Pause);
  }

  create() {
    const { width, height } = this.scale;
    const campaign = GameState.instance.campaign;
    this.add.rectangle(width / 2, height / 2, width, height, VisualTheme.colors.ink, 0.98);
    addPanel(this, width / 2, height / 2, 660, 650, { fill: VisualTheme.colors.night, alpha: 0.98, stroke: VisualTheme.colors.goldBright });
    this.add.text(width / 2, height / 2 - 258, 'Campaign Paused', { fontFamily: VisualTheme.fonts.display, fontSize: '42px', color: VisualTheme.text.title, stroke: '#100a06', strokeThickness: 3 }).setOrigin(0.5);
    if (campaign) this.add.text(width / 2, height / 2 - 208, `${campaign.scenarioId.replaceAll('_', ' ')}  •  Turn ${campaign.turn}`, { fontFamily: VisualTheme.fonts.body, fontSize: '18px', color: VisualTheme.text.accent }).setOrigin(0.5);

    createTextButton(this, { label: 'Resume Campaign', x: width / 2, y: height / 2 - 130, width: 320, onClick: () => this.scene.start(SceneKeys.CampaignMap) });
    createTextButton(this, { label: 'Save Autosave', x: width / 2, y: height / 2 - 60, width: 320, onClick: () => { if (campaign) SaveManager.instance.save(); } });
    createTextButton(this, { label: 'Guided Tutorial', x: width / 2, y: height / 2 + 10, width: 320, onClick: () => { this.scene.pause(); this.scene.launch(SceneKeys.Tutorial, { returnScene: SceneKeys.Pause }); } });
    createTextButton(this, { label: 'Settings & Accessibility', x: width / 2, y: height / 2 + 80, width: 320, onClick: () => { this.scene.pause(); this.scene.launch(SceneKeys.Settings, { returnScene: SceneKeys.Pause }); } });
    createTextButton(this, { label: 'Return to Title', x: width / 2, y: height / 2 + 150, width: 320, onClick: () => this.scene.start(SceneKeys.Title) });

    this.add.text(width / 2, height / 2 + 236, 'F1 opens the guide  •  F10 opens settings  •  Tab or gamepad navigates', { fontFamily: VisualTheme.fonts.body, fontSize: '15px', color: VisualTheme.text.muted }).setOrigin(0.5);
  }
}
